import './App.css';
import background from "./../src/images/background.gif"
import logo from "./../src/images/logo.jpg"
import gradient from "./../src/images/gradient.png"
import { useState, useEffect, useRef } from 'react';

function App() {
    const [showNavLogo, setShowNavLogo] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);
    const heroLogoRef = useRef(null);

    useEffect(function() {
        function handleScroll() {
            if (heroLogoRef.current) {
                var rect = heroLogoRef.current.getBoundingClientRect();
                setShowNavLogo(rect.bottom < 60);
            }
        }
        window.addEventListener('scroll', handleScroll);
        return function() {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    function toggleMenu() {
        setMenuOpen(!menuOpen);
    }

    function openPrivacy() {
        setShowPrivacy(true);
        setMenuOpen(false);
        window.scrollTo(0, 0);
    }

    function closePrivacy() {
        setShowPrivacy(false);
        window.scrollTo(0, 0);
    }

    if (showPrivacy) {
        return (
            <div className="App" style={{fontFamily: "'Nunito', sans-serif"}}>
                <header className="fixed top-0 left-0 w-full bg-gray-900 z-[90] px-6 py-3 heading-font">
                    <nav className="max-w-8xl mx-auto flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <img src={logo} alt="Logo" className="nav-logo nav-logo-visible" />
                        </div>
                        <div className="hidden md:flex gap-6 items-center">
                            <button onClick={closePrivacy} className="nav-link">Back to Home</button>
                        </div>
                        <button className={"hamburger md:hidden"} onClick={closePrivacy}>
                            <span className="text-white text-2xl">✕</span>
                        </button>
                    </nav>
                </header>

                <main className="w-full min-h-screen bg-gray-900 text-white relative z-10 pt-24 px-6 pb-20">
                    <div className="max-w-[700px] mx-auto">
                        <h1 className="text-5xl heading-font mb-6">Privacy Policy</h1>
                        <p className="text-sm text-white/40 mb-8">Last updated: August 2026</p>

                        <h2 className="text-2xl heading-font mt-8 mb-3">1. Information We Collect</h2>
                        <p className="text-white/70 leading-relaxed mb-4">
                            When you play Trust Me, I Work Here, we may collect basic gameplay data such as session length, in-game actions, and crash reports. If you use voice features, audio is processed in real-time and is not stored on our servers.
                        </p>

                        <h2 className="text-2xl heading-font mt-8 mb-3">2. How We Use Your Information</h2>
                        <p className="text-white/70 leading-relaxed mb-4">
                            We use collected data to improve gameplay, fix bugs, and balance game mechanics. We do not sell your personal data to third parties.
                        </p>

                        <h2 className="text-2xl heading-font mt-8 mb-3">3. Voice Data</h2>
                        <p className="text-white/70 leading-relaxed mb-4">
                            Voice input is processed locally or via secure real-time services to enable NPC interactions. We do not record, store, or use voice data for training purposes.
                        </p>

                        <h2 className="text-2xl heading-font mt-8 mb-3">4. Third-Party Services</h2>
                        <p className="text-white/70 leading-relaxed mb-4">
                            The game is distributed through Steam, which has its own privacy policy. We recommend reviewing Valve's privacy policy for information about data collected through the Steam platform.
                        </p>

                        <h2 className="text-2xl heading-font mt-8 mb-3">5. Children's Privacy</h2>
                        <p className="text-white/70 leading-relaxed mb-4">
                            Trust Me, I Work Here is not directed at children under 13. We do not knowingly collect information from children under 13.
                        </p>

                        <h2 className="text-2xl heading-font mt-8 mb-3">6. Contact</h2>
                        <p className="text-white/70 leading-relaxed mb-4">
                            For privacy-related questions, contact CrashTest Games at privacy@crashtestgames.nl.
                        </p>

                        <button onClick={closePrivacy} className="btn-chunky btn-blue heading-font mt-8">← Back to Home</button>
                    </div>
                </main>

                <footer className="w-full bg-gray-950 text-white/30 text-sm text-center py-6 px-6">
                    <p>© 2026 CrashTest Games. All rights reserved.</p>
                </footer>
            </div>
        );
    }

    return (
        <div className="App" style={{fontFamily: "'Nunito', sans-serif"}}>
            <header className="fixed top-0 left-0 w-full bg-gray-900 z-[90] px-6 py-3 heading-font">
                <nav className="max-w-8xl mx-auto flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <img
                            src={logo}
                            alt="Logo"
                            className={"nav-logo " + (showNavLogo ? "nav-logo-visible" : "")}
                        />
                    </div>

                    <div className="hidden md:flex gap-6 items-center">
                        <a href="#about" className="nav-link">About</a>
                        <a href="#" className="nav-link">Press Kit</a>
                        <a href="#" className="nav-link">For Investors</a>
                        <a href="https://store.steampowered.com/app/4354600/Trust_Me_I_Work_Here/" target="_blank" rel="noopener noreferrer" className="nav-cta">Wishlist</a>
                    </div>

                    <button
                        className={"hamburger md:hidden " + (menuOpen ? "hamburger-open" : "")}
                        onClick={toggleMenu}
                    >
                        <span className="hamburger-line"></span>
                        <span className="hamburger-line"></span>
                        <span className="hamburger-line"></span>
                    </button>
                </nav>

                <div className={"mobile-menu md:hidden " + (menuOpen ? "mobile-menu-open" : "")}>
                    <a href="#about" className="mobile-link">About</a>
                    <a href="#" className="mobile-link">Press Kit</a>
                    <a href="#" className="mobile-link">For Investors</a>
                    <a href="https://store.steampowered.com/app/4354600/Trust_Me_I_Work_Here/" target="_blank" rel="noopener noreferrer" className="nav-cta mobile-cta">Wishlist</a>
                </div>
            </header>

            <div className="fixed inset-0 z-0">
                <img
                    src={background}
                    alt=""
                    className="w-full h-full object-cover object-center brightness-[0.4]"
                />
            </div>

            <main className="w-full overflow-x-hidden relative z-10">
                <section className="w-full h-screen overflow-hidden relative z-30">
                    <div className="w-full h-full absolute z-[30] hero-gradient"></div>
                    <div className="z-[40] relative w-full xl:w-1/2 flex mt-[250px] items-center flex-col h-full px-6">
                        <img
                            ref={heroLogoRef}
                            src={logo}
                            className="w-[500px] hero-logo"
                        />
                        <p className="text-white text-xl max-w-[500px] hero-text">
                            A multiplayer heist game where
                            you pose as different roles and talk your way past guards through dynamic, unscripted voice
                            conversations.
                        </p>
                        <div className="mt-4 flex flex-row gap-5">
                            <a href="https://store.steampowered.com/app/4354600/Trust_Me_I_Work_Here/" target="_blank" rel="noopener noreferrer" className="btn-chunky btn-blue heading-font">Wishlist on Steam</a>
                            <a href="#" className="btn-chunky btn-white heading-font">Watch Trailer</a>
                        </div>
                    </div>
                </section>

                <section id="about" className="w-full text-white flex relative items-center bg-gray-900 overflow-hidden flex-col px-6 py-20">
                    <img
                        src={gradient}
                        className="w-[600px] absolute rotate-[135deg] top-[-400px] right-[-100px] opacity-[10%]"
                    />
                    <h1 className="mt-20 text-6xl heading-font">About</h1>
                    <p className="drop-shadow-xl text-center mt-2 max-w-[600px]">
                        Trust Me, I Work Here is being built by CrashTest Games, four Dutch developers based in South Holland. Expected late 2026.
                    </p>

                    <h2 className="mt-16 text-4xl heading-font">Gameplay</h2>
                    <p className="drop-shadow-xl text-center mt-2 max-w-[600px]">
                        No guns. Just your voice. Every NPC understands human speech <i>(no generative AI)</i>, so instead of shooting your way through a museum, you talk your way in.
                        <br /><br />
                        Each round drops your crew into a random location with a random cover story. You might be a magician in a museum or a neuroscientist at a frat party. If the story's bold enough, you're in.
                    </p>

                    <h2 className="mt-16 text-4xl heading-font">How a Round Works</h2>
                    <ul className="mt-4 max-w-[600px] mx-auto flex flex-col gap-2">
                        <li>Gear up and pick two outfits each</li>
                        <li>Ride the bus to a random location</li>
                        <li>Retrieve the target items. Lie, distract, or sneak</li>
                        <li>Sell your story or watch everything spiral into chaos</li>
                        <li>Earn Jack Coins from Jack D. Pimp after a successful mission</li>
                        <li>Keep going until you run out of arrests. No HP, just consequences</li>
                    </ul>
                </section>
            </main>

            <footer className="w-full bg-gray-950 relative z-10 py-8 px-6">
                <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="text-white/30 text-sm">© 2026 CrashTest Games. All rights reserved.</p>
                    <div className="flex gap-6 items-center heading-font text-sm">
                        <button onClick={openPrivacy} className="footer-link">Privacy Policy</button>
                        <a href="https://store.steampowered.com/app/4354600/Trust_Me_I_Work_Here/" target="_blank" rel="noopener noreferrer" className="footer-link">Steam</a>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default App;